export const INIT_TIMEOUT_MS = 5_000;
export const INIT_MAX_ATTEMPTS = 5;
export const INIT_RETRY_COOLDOWN_MS = 60_000;
export class BidderInitTimeoutError extends Error {
    constructor(partner) {
        super(`${partner} bidder init timed out after ${INIT_TIMEOUT_MS}ms`);
        this.name = 'BidderInitTimeoutError';
    }
}
